export default __webpack_public_path__ + "assets/jumbotron-720w.6d735fc5.webp";